import { MessageType } from '@/shared/hooks/use-ws/types';
import { AnalyticsService } from '@/shared/service/analytics/analytics-service';

import { Method } from '../../types';
import { validateMessageData } from '../validate-message-data';
import { warnIncorrectValues } from '../warn-incorrect-values';

export const gameAnalyticEventSendHandler = (value: any, sessionId: string) => {
  if (!validateMessageData({ value, allowedTypes: ['object'] })) {
    warnIncorrectValues(Method.SEND_ANALYTICS, 'analyticsData', ['object']);
  }

  const resolvedValue = {
    ...value,
    user_properties: { ...value?.user_properties, session_id: sessionId },
  };

  const event = { ...resolvedValue, created: Date.now() };

  AnalyticsService.send(event, MessageType.GAME_ANALYTICS);
};
